export default "__VITE_ASSET__a9416f88__"